import React from 'react';
import GraphTreeProtocol from '../graphics/GraphTreeProtocol.js';
import './Module.css';

const DocumentRetrievalModule = ({user, reportId, isSmallScreen}) => {
    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            <h2 className='module-title'>Document Retrieval Flow</h2>
            <GraphTreeProtocol user={user} reportId={reportId} />
        </div>
    );
};

export default DocumentRetrievalModule;
